export const primary = '#ff5a5a'
export const secondary = '#34e2d9'
export const white = '#FFFFFF'
export const grayLight = '#d1d7db'
export const gray = '#767676'
export const grayExtraDark = '#1D2330'
export const text = '#333333'
export const blue = '#092c4f'